<template>
  <v-container fluid class="savitarna-toolbar justify-center">
    <div v-html="content" />
  </v-container>
</template>
<script>
import headerData from './headerData'
import request from '@/utils/savitarnaMenu'
import store from '@/store'

export default {
  name: 'SavToolbar',
  mixins: [headerData],
  data() {
    return {
      content: null,
      aliveTimer: null,
      aliveTimeout: 60000,
    }
  },
  computed: {
    isLocal() {
      return process.env.VUE_APP_LOCAL === 'local'
    },
    isDevelop() {
      return process.env.VUE_APP_LOCAL === 'develop'
    },
  },
  beforeCreate() {
    this.$root.$off(`updateSavToolbar`)
  },
  created() {
    this.getData(true)
    this.$root.$on(`updateSavToolbar`, () => {
      this.getData()
    })
  },
  methods: {
    getData(first = false) {
      const xid = store.getters.getXid
      if (!this.isLocal && xid) {
        // const xid = this.$route.query.xid
        request({
          url: `menu.do;jsessionid=${xid}`,
          method: 'get',
        })
          .then((res) => {
            let fullMenu = res.data
            if (!this.checkMenu(fullMenu)) {
              if (first) {
                this.$root.$emit('SAV_LOGIN_ERROR')
              } else {
                this.$root.$emit('SAV_UNAUTHORIZED_ERROR')
              }
              return
            }
            this.content = this.parseTopHeader(fullMenu)
            if (!this.aliveTimer) {
              this.aliveTimer = setInterval(() => {
                this.getData()
              }, this.aliveTimeout)
            }
            this.getCartUrl(this.content)
            this.getSavitarnaHomeUrl(this.content)
            this.getBreadcrumbs(fullMenu)
            this.$emit('loaded')
          })
          .catch((err) => {
            clearInterval(this.aliveTimer)
            this.aliveTimer = null
            if (!this.isLocal && first) {
              this.$root.$emit('SAV_UNAUTHORIZED_ERROR')
            }
          })
      } else {
        if (this.isLocal || this.isDevelop) {
          this.content = this.parseTopHeader(this.menuData)
          this.getCartUrl(this.content)
          this.getSavitarnaHomeUrl(this.content)
          this.getBreadcrumbs(this.menuData)
          this.$emit('loaded')
        } else {
          clearInterval(this.aliveTimer)
          this.aliveTimer = null
          this.$root.$emit('SAV_UNAUTHORIZED_ERROR')
        }
      }
    },
    checkMenu(data) {
      return data.includes('<div id="info-panel">')
    },
    parseTopHeader(data) {
      let header = data
      header = header.replace(/^.*?(?=<div id="info-panel">)/s, '')
      header = header.replace(/(?=<div id="content-in">).*?$/s, '')
      return header
    },
    getCartUrl(data) {
      let subStart = data.indexOf('id="sav_basket"')
      if (subStart > 0) {
        let subEnd = data.indexOf('>', subStart)
        let subData = data.substring(subStart, subEnd)

        let urlRegex = /(https?:\/\/[^"]*)/
        let url = subData.match(urlRegex)[1].trim()

        this.$store.dispatch('savitarnaCartUrl', url)
      }
    },
    getSavitarnaHomeUrl(data) {
      let subStart = data.indexOf('id="sav_rcLogo2"')
      if (subStart > 0) {
        let subEnd = data.indexOf('>', subStart)
        let subData = data.substring(subStart, subEnd)

        let urlRegex = /(https?:\/\/[^"]*)/
        let url = subData.match(urlRegex)[1].trim()

        this.$store.dispatch('savitarnaHomeUrl', url)
      }
    },
    getBreadcrumbs(data) {
      let crumbs = data
      if (crumbs) {
        crumbs = crumbs.replace(/^.*?(?=<ul class="path">)/s, '')
        crumbs = crumbs.replace(/(?=<div class="print-top">).*?$/s, '')
        crumbs = crumbs.replaceAll('\n', '')

        if (crumbs && crumbs.length > 0) {
          let result = []
          let ahref = crumbs
          // ahref = ahref.match(/<a[^>]+>(.*[^<\/a>]+)<\/a>/g)
          ahref = ahref.match(/<a[^<]+<\/a>/g)

          if (ahref && ahref.length > 0) {
            result = ahref.map(function (val) {
              let url = val.match(/(https?:\/\/[^"]*)/)[1].trim()
              let name = val.match(/>(.*[^<])<\/a>/)[1].trim()
              return { text: name, href: url, exact: true, disabled: false }
            })
          }
          this.$store.dispatch('savitarnaBreadcrumbs', result)
        }
      }
    },
  },
}
</script>

<style lang="scss">
.savitarna-toolbar {
  padding: 0;
  background: #fff;
}
#info-panel {
  height: 27px !important;
}
.site-info {
  margin-top: 5px !important;
}
</style>
